<template>
  <!--  订单拣货-->
  <div class="OrderPicking">
    <div class="OrderPicking__left">
      <el-calendar v-model="filterDate"></el-calendar>
    </div>
    <div class="OrderPicking__right">
      <div class="fs20">拣货结算同步</div>
      <el-divider></el-divider>
      <div class="marginBottom10 flex flexSpaceBetween">
        <el-button :loading="loading" :disabled="syncBtn" type="primary" size="medium" @click="handleSync">
          <span>同步到YS</span>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">批量按钮,通过接YS销售订单接口推送拣货结算的数据</div>
            <i class="el-icon-question" style="margin-left: 5px"></i>
          </el-tooltip>
        </el-button>
      </div>
      <div class="padding10 bcGrey">当前选中 {{ selectIds.length }} 项 <a class="blue" @click="toggleSelection">取消选择</a></div>
      <div class="flexGrow1">
        <el-table ref="multipleTable" v-loading="loading" element-loading-spinner="el-icon-loading" :element-loading-text="loadingMsg" height="500" :data="tableData" @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column label="序号" align="center" type="index" width="55" />
          <el-table-column label="YS销售单号" align="center" prop="cthirdOrderCode" />
          <el-table-column label="出货日期" align="center" prop="tout" sortable="custom">
            <template #default="scope">
              <div>{{ scope.row.tout }}</div>
            </template>
          </el-table-column>
          <el-table-column label="订单渠道" align="center" prop="rchannel" sortable="custom">
            <template #default="scope">
              <template v-for="item in channelOptions">
                <template v-if="scope.row.rchannel.includes(item.code)">
                  {{ item.name }}
                </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="财务关系" align="center" prop="cfinance" sortable="custom">
            <template #default="scope">
              <template v-for="item in financialOptions">
                <template v-if="scope.row.cfinance.includes(item.id)">
                  {{ item.name }}
                </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="门店编号" align="center" prop="cstore" sortable="custom" />
          <el-table-column label="门店名称" align="center" prop="sstore" />
          <el-table-column label="状态" align="center" prop="bstatus" sortable="custom">
            <template #default="scope">
              <div v-if="scope.row.bstatus === 1" style="color: blue">等待同步</div>
              <div v-else-if="scope.row.bstatus === 3" style="color: red">同步失败</div>
              <div v-else style="color: green">同步成功</div>
            </template>
          </el-table-column>
          <el-table-column label="同步时间" align="center" prop="tsync" sortable="custom">
            <template #default="scope">
              <div>{{ scope.row.tsync | time }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="scope">
              <el-button size="mini" type="text" @click="handleDetail(scope.row.sid)">详情</el-button>
              <el-button v-show="scope.row.bstatus === 3" size="mini" type="text" @click="handleSingleSync(scope.row.sid)">同步</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="h50">
        <el-pagination :current-page="queryParams.pageNum" :page-sizes="[50, 100, 200, 300, 500]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <el-dialog title="门店日拣货汇总" width="70%" :visible.sync="dialogVisible" append-to-body>
      <OrderPickingSettleDetail ref="detailDialog" :visible.sync="dialogVisible" :channel-options="channelOptions" :financial-options="financialOptions" @ref="queryPageList"></OrderPickingSettleDetail>
    </el-dialog>
  </div>
</template>
<script>
import { ordPickingSettleList, ordPickingSettleSync, ordPickingSettleFinancial } from "@/api/store/ordPicking";
import moment from "moment/moment";
import OrderPickingSettleDetail from "@/views/order/dialog/settleDetail.vue";
import { formatTime } from "@/utils/utils";
export default {
  name: "OrderPickingSettle",
  components: { OrderPickingSettleDetail },
  filters: {
    time(value) {
      if (value) {
        return formatTime(value);
      }
    },
  },
  data() {
    return {
      filterDate: new Date(),
      // 分页
      queryParams: {
        pageNum: 1,
        pageSize: 50,
        orderByColumn: "",
        isAsc: "",
        filterDate: undefined,
      },
      total: 0,
      // 表格
      tableData: [],
      loading: false,
      loadingMsg: "",
      // 选中id
      selectIds: [],
      channelOptions: [],
      financialOptions: [],
      syncBtn: true,
      sortCustom: {
        tout: "t_out",
        rchannel: "r_channel",
        cfinance: "c_finance",
        cstore: "c_store",
        bstatus: "b_status",
        tsync: "t_sync",
      },

      /** dialog  **/
      dialogVisible: false,
    };
  },
  watch: {
    filterDate() {
      this.queryPageList();
    },
  },
  created() {
    this.selectAllChannel();
    this.selectFinancial();
    this.queryPageList();
  },
  methods: {
    toggleSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    // 分页
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryPageList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.queryPageList();
    },
    // 查询
    queryPageList() {
      this.loading = true;
      this.queryParams.filterDate = moment(this.filterDate).format("YYYY-MM-DD");
      ordPickingSettleList(this.queryParams).then((res) => {
        this.total = res.total;
        this.tableData = res.rows;
        this.loading = false;
      });
    },
    /** 排序触发事件 */
    handleSortChange({ prop, order }) {
      if (order) {
        this.queryParams.orderByColumn = this.sortCustom[prop];
        this.queryParams.isAsc = order === "ascending" ? "asc" : "desc";
        this.queryPageList();
      }
    },
    handleSelectionChange(selection) {
      this.selectIds = selection.map((item) => item.sid);
      // 符合条件开放按钮
      if (this.selectIds.length > 0) {
        const judge = selection.filter((item) => item.bstatus === 3);
        this.syncBtn = judge.length !== this.selectIds.length;
      } else {
        this.syncBtn = true;
      }
    },
    sync(arr) {
      this.loading = true;
      this.loadingMsg = "正在同步到YS,请耐心等候...";
      ordPickingSettleSync(arr)
        .then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.queryPageList();
          this.loading = false;
          this.loadingMsg = "";
        })
        .catch(() => {
          this.loading = false;
          this.loadingMsg = "";
        });
    },
    handleSingleSync(sid) {
      this.sync([sid]);
    },
    handleSync() {
      if (this.selectIds.length <= 0) {
        this.$message({
          message: "请选择结算单",
          type: "error",
        });
        return;
      }
      this.sync(this.selectIds);
    },
    handleDetail(sid) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.detailDialog.getData(sid);
      });
    },
    selectAllChannel() {
      let url = `${this.baseUrls.ordPicking}/selectAllChannel`;
      this.topsAjax.get(url).then((response) => {
        this.channelOptions = response;
      });
    },
    selectFinancial() {
      ordPickingSettleFinancial().then((res) => {
        this.financialOptions = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.OrderPicking {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  padding: 3px;

  .el-divider--horizontal {
    margin: 10px 0;
  }

  &__left {
    margin-right: 20px;
    width: 15%;
    display: flex;
    flex-direction: column;
    background-color: white;
    box-shadow: 1px 1px 5px #888888;
    z-index: 100;
    position: relative;
  }

  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: white;
    box-shadow: 1px 1px 5px #888888;
    z-index: 100;
    position: relative;
    padding: 20px 10px;

    .el-radio-button__inner {
      width: auto;
    }
  }
  ::v-deep .el-calendar-table .el-calendar-day {
    width: 100%;
    height: 30px;
    text-align: center;
  }
}
</style>
